import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  NumberFormats,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { AxisLabelSortOrder } from '../../types';

export type EchartsLineFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormColumn[];
    metric: QueryFormMetric;
    showLabels: boolean;
    colorScheme?: string;
    smooth: boolean;
    sortLabels: AxisLabelSortOrder;
    numberFormat: string;
};

export interface EchartsLineChartProps
  extends ChartProps<EchartsLineFormData> {
  formData: EchartsLineFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsLineFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  columns: [],
  showLabels: true,
  smooth: false,
  sortLabels: AxisLabelSortOrder.None,
  numberFormat: NumberFormats.ORIGINAL
};

export interface LineChartTransformedProps {
  formData: EchartsLineFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}